import { getHours, getMinutes } from 'date-fns';
import { EPG_SELECTORS } from 'helpers/variables';
const { EPG_CLASS } = EPG_SELECTORS;

//********************** Progress bar **********************
// Initial progress bar's position
export const initialProgressBar = ({ epgItemWidth, epgWidth }) => {
	const currentTime = getHours(new Date());
	const position = epgWidth * currentTime + 120;
	return {
		scrollToCurrentTime: position <= epgItemWidth ? true : false,
		position
	};
};

// Update time progressbar
export const updateProgressBar = (epgItemWidth) => {
	const hours = getHours(new Date());
	const minutes = getMinutes(new Date());

	const width = epgItemWidth * hours + (epgItemWidth / 60) * minutes;

	return width;
};

// Initial epg's scroll left position
export const initialEpgPosition = ({
	epgItemWidth,
	timeout = 600,
	isMobile = false
}) =>
	// Set initial scrollLeft
	setTimeout(() => {
		const epg = document.querySelector(`.${EPG_CLASS}`);
		if (epg) {
			const proportionIndex = isMobile ? 0.5 : 2;
			epg.scrollLeft =
				updateProgressBar(epgItemWidth) - epgItemWidth * proportionIndex;
		}
	}, timeout);
